
import { VersionDetailPanel } from "@/components/settings/versions/Detail";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusCircleOutlined,
  ExportOutlined,
  ImportOutlined
} from "@ant-design/icons";
import { Button, Modal, Dropdown, Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdate, useInvalidate } from "@refinedev/core";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useResourceDelete } from "@/hooks/useResourceDelete";

export const NAV_TO_VERSION_LIST = "settings/versions";
export const RESOURCE_TYPE_VERSIONS = "versionSettings";

export const VersionDetailTabs = () => {
  let tabs = [
    {
      key: "details",
      label: "Details",
      children: <VersionDetailPanel />,
    },
  ]
  return tabs;
};

export const VersionActions = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useResourceContext();
  const navigate = useResourceNavigate();
  const invalidate = useInvalidate();
  const [selected] = state.selectedResources;

  const navigateToCreation = () => {
    navigate({ resource: NAV_TO_VERSION_LIST, action: "create" });
  };
  const { mutateAsync: deleteMutate } = useResourceDelete();
  const { mutate, isLoading: isUpdating } = useUpdate({
    successNotification: (response, { id, values }, resource) => {
      const { action, data } = values;
      return {
        message: t(`settings.actionResult.${action}.success`, { resource:"AIOps version", id }),
        description: "Success",
        type: "success",
      };
    },
  });

  const actionsMenu = [
    { key: "edit", label: (<span><EditOutlined /> {t("settings.menu.edit")}</span>), disabled: !selected },
    { key: "export", label: (<span><ExportOutlined /> {t("settings.menu.export")}</span>), disabled: !selected },
    { key: "import", label: (<span><ImportOutlined /> {t("settings.menu.import")}</span>) },
    { key: "delete", label:(<span>
      <DeleteOutlined /> {t("settings.menu.delete")}
      </span>), disabled: !selected },
  ];

  const onClickAction = (item) => {
    const [selected] = state.selectedResources;
    console.log("Action:", selected.sprint, item.key);
    if (item.key === "delete") {
      deleteMutate({
        resource: RESOURCE_TYPE_VERSIONS,
        id: selected.sprint,
      });
    } else if(item.key === "import") {
      navigate({
        resource: NAV_TO_VERSION_LIST,
        action: item.key,
        key: "version",
      });
    } else {
      navigate({
        resource: NAV_TO_VERSION_LIST,
        action: item.key,
        key: selected.sprint,
      });
    }
  };

  const buttons = [
    <Dropdown
      key="action"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("pools.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    
    <Button
      key="launch"
      icon={<PlusCircleOutlined />}
      onClick={navigateToCreation}
    >
      {t("settings.versions.menu.launch")}
    </Button>,

    <RefreshButton
      key="refresh"
      onClick={() => {
        invalidate({
          resource: RESOURCE_TYPE_VERSIONS,
          invalidates: ["list"],
        });
      }}
    />,
  ];
  return <Space>{buttons}</Space>;
};
